import GeneralLedgerAccountType from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountType";

export default (generalLedgerAccountType: GeneralLedgerAccountType) => {
    let returnVal = "Undefined";
    switch (generalLedgerAccountType) {
        case GeneralLedgerAccountType.Asset:
            returnVal = "Asset";
            break;
        case GeneralLedgerAccountType.Liability:
            returnVal = "Liability";
            break;
        case GeneralLedgerAccountType.Income:
            returnVal = "Income";
            break;
        case GeneralLedgerAccountType.Expense:
            returnVal = "Expense";
            break;
        case GeneralLedgerAccountType.Equity:
            returnVal = "Equity";
            break;
    }
    return returnVal;
}